module.exports = "/_next/static/images/34fb868274262caa2d61e80c462543d1-xpeer-fgts@1x.jpg";